import React from 'react';
import ChatBoxComponent from '../../components/ChatBoxComponent';

const ChatPage = () => {
  return (
      <ChatBoxComponent/>
  )
}

export default ChatPage;
